import { BaseAPI, Configuration } from "./lib-api";

export const apiConfiguration = new Configuration({
  basePath: window.location.protocol + "//" + window.location.host,
});

export const ReCAPTCHASiteKey = "6Lc4304eAAAAAJ99u8pRHC4DS7pZanzszHRW-mWh";

export function withCsrf<T extends BaseAPI>(api: T, csrf: string) {
  return api.withMiddleware({
    pre: async (context) => ({
      ...context,
      init: {
        ...context.init,
        headers: {
          ...context.init.headers,
          RequestVerificationToken: csrf,
        },
      },
    }),
  });
}
